<template>
  <div>
    <loading-screen v-if="isLoading" />
    <div class="p-4 recurrence-container">
      <div
        v-for="service in services"
        :key="service.id"
        class="p-2 border-bottom"
      >
        <template v-if="service.isValid">
          <div>
            <p>N&uacute;mero</p>
            <p class="text-danger">
              {{ service.formattedClientId }}
            </p>
          </div>
          <div class="text-center">
            <p v-if="service.isRecurrent">
              <span class="p-2"><check
                scale="2"
                color="green"
              /><br /></span>
              Pago autom&aacute;tico registrado
            </p>
            <p v-else>
              <span class="p-1"><x-circle
                scale="2"
                color="green"
              /><br /></span>
              Sin pago autom&aacute;tico
            </p>
          </div>
          <div class="text-center">
            <template v-if="service.isRecurrent">
              <p>Pr&oacute;ximo intento de cobro:</p>
              <p>{{ service.nextAttempt | local }}</p>
            </template>
            <template v-else>
              <p>Adeudo</p>
              <p>{{ country.money }}{{ service.dueAmount | toFixed }}</p>
            </template>
          </div>
          <div>
            <notification-data-update-dialog
              v-if="service.isRecurrent"
              :service="service"
            />
            <add-recurrence-dialog
              v-else
              :service="service"
            />
          </div>
          <div>
            <cancel-recurrence-dialog
              v-if="service.isRecurrent"
              :service="service"
            />
          </div>
        </template>
        <template v-else>
          <div
            align-self="space-between"
            cols="3"
          >
            <div>N&uacute;mero</div>
            <div class="text-danger">
              {{ service.formattedClientId }}
            </div>
          </div>
          <div align-self="center">
            <div class="text-danger">
              <exclamation-circle
                scale="3"
                color="red"
                class="mr-3"
              />
              No es posible mostrar esta información
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import storage from '@lagersoft/key-storage';
import { mapGetters } from 'vuex';
import { ExclamationCircle, Check, XCircle } from '@/components/icons';
import NotificationDataUpdateDialog from './NotificationDataUpdateDialog';
import AddRecurrenceDialog from './AddRecurrenceDialog';
import CancelRecurrenceDialog from './CancelRecurrenceDialog';
import getUrlParams from '../../utils/getUrlParams';

export default {
  name: 'MyServiceNumbers',
  components: {
    NotificationDataUpdateDialog,
    AddRecurrenceDialog,
    CancelRecurrenceDialog,
    ExclamationCircle,
    Check,
    XCircle
  },
  data() {
    return {
      services: [],
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['country'])
  },
  created() {
    if (getUrlParams('t')) {
      const token = getUrlParams('t');
      // storage.set('tokenMCW', token.split('?orderId=')[0]);
      storage.set('tokenRecurrentInvoices', token);
    }
    this.getRecurrenceInvoices();
  },
  methods: {
    getRecurrenceInvoices() {
      this.isLoading = true;
      global.api.mcwGetRecurrenceInvoices().then((res) => {
        this.services = res.data;
      }).catch(() => {
        this.$router.push({ name: 'ErrorRecurrenceInvoices', query: { error: 'GENERIC_ERROR' } });
      }).finally(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .recurrence-container {
    @media only screen and (max-width: 600px) {
      font-size: 12px;
      button {
        font-size: 12px;
      }
    }
  }
</style>
